/* eslint-disable react-hooks/exhaustive-deps */
import { Pagination, PaginationItem } from '@mui/material';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import DeleteIcon from '../../../assets/icons/adminDelete.svg';
import EditarIcon from '../../../assets/icons/adminEdit.svg';
import CloseIcon from '../../../assets/icons/close.svg';
import api from '../../../services/api';
import handleError from '../../../utils/handleError';
import { ModalConfirm } from '../../../shared/ModalConfirm/ModalConfirm';
import { ModalSuport } from '../ModalSuport/ModalSuport';
import {
  Button,
  ButtonsContainer,
  Close,
  CloseButton,
  Container,
  Content,
  Icon,
  IconButton,
  ModalHeader,
  PaginationWrapper,
  RowContainer,
  Table,
  TableWrapper,
  TdCode,
  Title,
} from './styles';

export interface IResponseSuport {
  results: Result[];
  page: number;
  limit: number;
  total: number;
}

export interface Result {
  id: string;
  name: string;
  phone: string;
  latitude: string;
  longitude: string;
  city: string;
  created_at: string;
}

const styles = {
  background: 'transparent',
  fontSize: '1rem',
  fontWeight: 500,
  margin: 0,
  padding: '0.125rem',
  minWidth: '1rem',
};

interface Props {
  setOpenModal: Dispatch<SetStateAction<boolean>>;
}

export const ModalSuportList: React.FC<Props> = ({ setOpenModal }) => {
  const [deletingId, setDeletingId] = useState<string | undefined>();
  const [suportData, setSuportData] = useState<Result | undefined>();
  const [registerModal, setRegisterModal] = useState(false);

  const [suports, setSuports] = useState<Result[]>([]);

  const [page, setPage] = useState(1);
  const [maximumPage, setMaximumPage] = useState(1);

  const getRoutes = async () => {
    try {
      const { data } = await api.get<IResponseSuport>(`/sos/contact`);

      setSuports(data.results || []);
      setMaximumPage(Math.ceil(data.total / 6));
    } catch (error: any) {
      handleError(error, 'error');
    }
  };

  useEffect(() => {
    getRoutes();
  }, [page]);

  const onDelete = async () => {
    if (!deletingId) return;

    try {
      await api.delete(`/sos/contact/${deletingId}`);

      setDeletingId(undefined);
      handleError('Suporte deletado com sucesso.', 'success');
      getRoutes();
    } catch (error: any) {
      handleError(error, 'error');
    }
  };

  return (
    <Container>
      <Content>
        <ModalHeader>
          <Title>Listagem de Boias</Title>
          <CloseButton onClick={() => setOpenModal(false)}>
            <Close src={CloseIcon} />
          </CloseButton>
        </ModalHeader>

        <RowContainer>
          <Button type="button" onClick={() => setRegisterModal(true)}>
            <FaPlus size={18} />
            Adicionar
          </Button>
        </RowContainer>

        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Telefone</th>
                <th>Latitude</th>
                <th>Longitude</th>
                <th>Cidade</th>
                <th style={{ textAlign: 'right' }}>Ações</th>
              </tr>
            </thead>

            <tbody>
              {suports?.map(code => (
                <tr key={code.id}>
                  <TdCode style={{ width: '180px' }}>{code.name}</TdCode>

                  <TdCode>{code.phone}</TdCode>

                  <TdCode>{code.latitude}</TdCode>

                  <TdCode>{code.longitude}</TdCode>

                  <TdCode>{code.city}</TdCode>

                  <TdCode
                    style={{
                      maxWidth: '350px',
                      minWidth: '350px',
                      textAlign: 'right',
                    }}
                  >
                    <ButtonsContainer>
                      <IconButton
                        type="button"
                        onClick={() => {
                          setSuportData(code);
                          setRegisterModal(true);
                        }}
                      >
                        <Icon src={EditarIcon} />
                      </IconButton>
                      <IconButton
                        type="button"
                        onClick={() => setDeletingId(code.id)}
                      >
                        <Icon src={DeleteIcon} />
                      </IconButton>
                    </ButtonsContainer>
                  </TdCode>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrapper>

        {maximumPage > 1 && (
          <PaginationWrapper>
            <Pagination
              page={page}
              count={maximumPage}
              siblingCount={1}
              onChange={(e, _page) => setPage(_page)}
              hidePrevButton={page === 1}
              hideNextButton={page === maximumPage}
              renderItem={item => {
                return (
                  <PaginationItem
                    {...item}
                    style={{
                      ...styles,
                      color: item.page === page ? '#4793CE' : '#888888',
                    }}
                    classes={{ icon: 'icon' }}
                  />
                );
              }}
            />
          </PaginationWrapper>
        )}
      </Content>

      {deletingId && (
        <ModalConfirm
          onCancel={() => setDeletingId(undefined)}
          onConfirm={onDelete}
          title="Tem certeza que deseja excluir esse suporte?"
        />
      )}

      {registerModal && (
        <ModalSuport
          suportData={suportData}
          onClose={() => {
            setRegisterModal(false);
            setSuportData(undefined);
            getRoutes();
          }}
        />
      )}
    </Container>
  );
};
